export default "__VITE_ASSET__bf8778c0__"